module.exports = __webpack_public_path__ + "static/img/pic_hd.166ce8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic_hd.jpg
// module id = 8n8q
// module chunks = 1